import type { FeatureFlags } from "@/lib/features";
import {
  ActivitySquare,
  ArrowDownToLine,
  ArrowUpFromLine,
  BarChart3,
  ClipboardList,
  Home,
  Inbox as InboxIcon,
  type LucideIcon,
  Mail,
  MessageSquare,
  Settings,
  Zap,
} from "lucide-react";

export interface NavItem {
  title: string;
  url: string;
  icon: LucideIcon;
  testId: string;
  navKey: string;
  featureKey?: keyof FeatureFlags;
  entityScoped?: boolean;
}

export interface MoreNavItem {
  navKey: string;
  url: string;
  titleKey: string;
  icon: LucideIcon;
  testId: string;
  mobileTestId: string;
  featureKey?: keyof FeatureFlags;
  awarenessKey?: string;
  separatorBefore?: boolean;
  isApprovalBadged?: boolean;
}

export const PRIMARY_NAV_ITEMS: NavItem[] = [
  {
    title: "nav.monitor",
    url: "/",
    icon: Home,
    testId: "link-home-nav",
    navKey: "home",
  },
  {
    title: "nav.getPaid",
    url: "/ar",
    icon: ArrowDownToLine,
    testId: "link-ar",
    navKey: "ar",
    featureKey: "ar",
    entityScoped: true,
  },
  {
    title: "nav.payBills",
    url: "/ap",
    icon: ArrowUpFromLine,
    testId: "link-ap",
    navKey: "ap",
    featureKey: "ap",
    entityScoped: true,
  },
];

export const MOBILE_PRIMARY_NAV_ITEMS: NavItem[] = [
  {
    title: "nav.mobile.monitor",
    url: "/",
    icon: Home,
    testId: "link-home-mobile",
    navKey: "home",
  },
  {
    title: "nav.getPaid",
    url: "/ar",
    icon: ArrowDownToLine,
    testId: "link-ar-mobile",
    navKey: "ar",
    featureKey: "ar",
    entityScoped: true,
  },
  {
    title: "nav.payBills",
    url: "/ap",
    icon: ArrowUpFromLine,
    testId: "link-ap-mobile",
    navKey: "ap",
    featureKey: "ap",
    entityScoped: true,
  },
];

export const MORE_NAV_ITEMS: MoreNavItem[] = [
  {
    navKey: "inbox",
    url: "/inbox",
    titleKey: "nav.inbox",
    icon: InboxIcon,
    testId: "menu-item-inbox",
    mobileTestId: "menu-item-inbox-mobile",
    isApprovalBadged: true,
  },
  {
    navKey: "automations",
    url: "/automations",
    titleKey: "nav.automations",
    icon: Zap,
    testId: "menu-item-automations",
    mobileTestId: "menu-item-automations-mobile",
    featureKey: "automations",
    awarenessKey: "automations",
  },
  {
    navKey: "reports",
    url: "/reports",
    titleKey: "nav.reports",
    icon: BarChart3,
    testId: "menu-item-reports",
    mobileTestId: "menu-item-reports-mobile",
    featureKey: "aiReports",
    awarenessKey: "aiReports",
  },
  {
    navKey: "chat",
    url: "/chat",
    titleKey: "nav.chat",
    icon: MessageSquare,
    testId: "menu-item-chat",
    mobileTestId: "menu-item-chat-mobile",
    featureKey: "aiChat",
  },
  {
    navKey: "tasks",
    url: "/tasks",
    titleKey: "nav.tasks",
    icon: ClipboardList,
    testId: "menu-item-tasks",
    mobileTestId: "menu-item-tasks-mobile",
    featureKey: "tasks",
  },
  {
    navKey: "communications",
    url: "/communications",
    titleKey: "nav.communications",
    icon: Mail,
    testId: "menu-item-communications",
    mobileTestId: "menu-item-communications-mobile",
    featureKey: "communications",
    awarenessKey: "communications",
  },
  {
    navKey: "system-health",
    url: "/system-health",
    titleKey: "nav.systemHealth",
    icon: ActivitySquare,
    testId: "menu-item-system-health",
    mobileTestId: "menu-item-system-health-mobile",
    separatorBefore: true,
  },
  {
    navKey: "settings",
    url: "/settings",
    titleKey: "nav.settings",
    icon: Settings,
    testId: "menu-item-settings",
    mobileTestId: "menu-item-settings-mobile",
  },
];
